export default __webpack_public_path__ + "9585aaa1f2dfc40f859f52ed69b8da74.png";